import { apiUrl, performApiRequest } from '@/infrastructure/api-requests';
import { GetProductDataDistributionQuery, GetProductIdentificationQuery, GetProductIdentificationsByEANQuery, GetProductIdentificationsByProjectNumberQuery, GetProductMasterDataQuery, GetProductOrdersQuery, GetProductRelatedSPPsQuery, GetProductRawImportQuery, GetProductRelatedCalendarsQuery, ProductDataDistribution, ProductIdentification, ProductMasterData, ProductOrders, ProductRelatedSPPs, ProductRawImport, ProductRelatedCalendars } from './types';

export function getProductIdentificationsByEAN(query: GetProductIdentificationsByEANQuery): Promise<ProductIdentification[]> {
  const url = `${apiUrl}/api/product-search/get-product-identifications-by-ean-query`;
  return performApiRequest({ url, method: 'POST', data: query });
}

export function getProductIdentificationsByProjectNumber(
  query: GetProductIdentificationsByProjectNumberQuery
): Promise<ProductIdentification[]> {
  const url = `${apiUrl}/api/product-search/get-product-identifications-by-project-number-query`;
  return performApiRequest({ url, method: 'POST', data: query });
}

export function getProductIdentification(query: GetProductIdentificationQuery): Promise<ProductIdentification> {
  const url = `${apiUrl}/api/product-search/get-product-identification-query`;
  return performApiRequest({ url, method: 'POST', data: query });
}

export function getProductMasterData(query: GetProductMasterDataQuery): Promise<ProductMasterData> {
  const url = `${apiUrl}/api/product-search/get-product-master-data-query`;
  return performApiRequest({ url, method: 'POST', data: query });
}

export function getProductDataDistribution(query: GetProductDataDistributionQuery): Promise<ProductDataDistribution> {
  const url = `${apiUrl}/api/product-search/get-product-data-distribution-query`;
  return performApiRequest({ url, method: 'POST', data: query });
}

export function getProductOrders(query: GetProductOrdersQuery): Promise<ProductOrders> {
  const url = `${apiUrl}/api/product-search/get-product-orders-query`;
  return performApiRequest({ url, method: 'POST', data: query });
}

export function getProductRelatedCalendars(query: GetProductRelatedCalendarsQuery): Promise<ProductRelatedCalendars> {
  const url = `${apiUrl}/api/product-search/get-product-related-calendars-query`;
  return performApiRequest({ url, method: 'POST', data: query });
}

export function getProductRelatedSPPs(query: GetProductRelatedSPPsQuery): Promise<ProductRelatedSPPs> {
  const url = `${apiUrl}/api/product-search/get-product-related-spps-query`;
  return performApiRequest({ url, method: 'POST', data: query });
}

export function getProductRawImport(query: GetProductRawImportQuery): Promise<ProductRawImport> {
  const url = `${apiUrl}/api/product-search/get-product-raw-import-query`;
  return performApiRequest({ url, method: 'POST', data: query });
}
